exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".company-header[data-v-6c80ed7b] {\n  text-transform: none;\n}\n.company-section .case-studies-slider[data-v-6c80ed7b] {\n  padding-top: 0px;\n}\n.company-section .case-company[data-v-6c80ed7b] {\n  width: 460px;\n  height: 385px;\n}", ""]);

// exports
